import React, { useState } from "react";

function FAQ() {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqData = [
    {
      question: "What are lead generation services?",
      answer: "Lead generation services assist corporations entice and capture capability clients who're interested in their products or services. These offerings use techniques like search engine marketing, social media advertising, email campaigns, and paid advertisements to generate brilliant leads.",
    },
    {
      question: "Why are lead generation services essential for corporations?",
      answer: "Lead technology services are important because they help organizations discover the proper target market, enhance conversion fees, and boom sales. Without right lead technology, groups may additionally war to develop and compete in the market.",
    },
    {
      question: "How do B2B lead era services paintings?",
      answer: "B2B lead technology services recognition on figuring out and targeting selection-makers in companies. They use facts-pushed strategies which includes electronic mail outreach, LinkedIn advertising and marketing, and content advertising to generate qualified leads.",
    },
    {
      question: "How long does it take to look effects from lead generation?",
      answer: "The results from lead era offerings can vary relying at the strategy used. Paid campaigns can generate leads fast, even as SEO and organic strategies may also take some weeks to months for steady outcomes.",
    },
    {
      question: "How do I pick the great lead generation agency in India?",
      answer: "To pick the proper lead generation company in india, look for enjoy, validated effects, patron critiques, and custom designed strategies. A proper agency will consciousness on delivering excellent leads as opposed to simply quantity.",
    },

  ];

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="k-faq-section">
      <div className="k-faq-container">
        <h2 className="k-faq-heading">Frequently Asked Questions</h2>

        {faqData.map((item, index) => (
          <div
            key={index}
            className={
              activeIndex === index ? "k-faq-box active" : "k-faq-box"
            }
          >
            <div
              className="k-faq-question"
              onClick={() => toggleFAQ(index)}
            >
              <span className="k-faq-title">{item.question}</span>
              <span className="k-faq-arrow">
                {activeIndex === index ? "▲" : "▼"}
              </span>
            </div>

            <div className="k-faq-answer">
              <p className="k-faq-text">{item.answer}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default FAQ;